/**
 * Payment Configuration Registry
 * Manages payment options for different form types
 */

import type { PaymentOption } from '../types';

export const AUTO_PAYMENT_OPTIONS: PaymentOption[] = [
  {
    carrier: ['Aviva'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      '4_pay': {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['CAA'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: null,
      annual: null,
    },
    monthly_installments_count: 12,
    loa_billing_required: false,
  },
  {
    carrier: ['Coachman'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 28],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Commonwell'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Echelon'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: true,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 28],
      annual: null,
    },
    monthly_installments_count: 12,
    loa_billing_required: false,
  },
  {
    carrier: ['Economical', 'Definity'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 12,
    loa_billing_required: false,
  },
  {
    carrier: ['Facility'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: true,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Hagerty'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      '2_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      '4_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Intact'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 11,
    loa_billing_required: false,
  },
  {
    carrier: ['Jevco'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 11,
    loa_billing_required: false,
  },
  {
    carrier: ['Pafco'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: true,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Pembridge'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Portage'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
  },
  {
    carrier: ['SGI'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 30],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: true,
  },
  {
    carrier: ['Travelers', 'Dominion'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Travelers Essentials'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Unica'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: null,
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Wawanesa'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: true,
      mastercard_debit: true,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 27],
      annual: null,
    },
    monthly_installments_count: 12,
    loa_billing_required: false,
  },
  {
    carrier: ['Peace Hills'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: [1, 31],
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Gore'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  // --- Non-standard / Specialty Markets (Personal Lines) ---
  {
    carrier: ['Premier Marine'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['April Marine'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Forward Insurance'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Coast Underwriters'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Oasis Outdoor Adventure'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Agile', 'Guardian Risk'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: true,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: true,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Agile UW', 'HABL'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['PAL'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Orbit', 'Aviva Elite Special Events'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Apollo'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Aviva Elite'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Optimum'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
    payment_date_config_overrides: { '3_pay': 'annual' },
    down_payment_accept_overrides: { '3_pay': false },
    payment_period_notices: {
      '3_pay':
        'If the three pay option is chosen, all 3 post-dated cheques are to be sent to Optimum by the client directly. Optimum does not offer three pay for online banking or credit card payments.',
    },
  },
];

export const PROPERTY_PAYMENT_OPTIONS: PaymentOption[] = [
  {
    carrier: ['Optimum'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
    payment_date_config_overrides: { '3_pay': 'annual' },
    down_payment_accept_overrides: { '3_pay': false },
    payment_period_notices: {
      '3_pay':
        'If the three pay option is chosen, all 3 post-dated cheques are to be sent to Optimum by the client directly. Optimum does not offer three pay for online banking or credit card payments.',
    },
  },
  {
    carrier: ['Aviva'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      '4_pay': {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Commonwell'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Economical', 'Definity'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: true,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 12,
    loa_billing_required: false,
  },
  {
    carrier: ['Intact'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 11,
    loa_billing_required: false,
  },
  {
    carrier: ['Max'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 27],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Pembridge'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Portage'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['SGI'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 30],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Travelers', 'Dominion'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Unica'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: null,
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Wawanesa'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 27],
      annual: null,
    },
    monthly_installments_count: 12,
    loa_billing_required: false,
  },
  {
    carrier: ['Peace Hills'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: true,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: true,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: true,
      e_transfer: true,
    },
    payment_dates: {
      other: [1, 31],
      annual: [1, 31],
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Gore'],
    payment_methods: {
      annual: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: true,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: true,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: [1, 31],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['SouthEastern Mutual'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: true,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: true,
      visa_debit: false,
      mastercard: true,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: {
      credit_card: false,
      e_transfer: false,
    },
    payment_dates: {
      other: ['15', '30'],
      annual: null,
    },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  // --- Non-standard / Specialty Markets (Personal Lines) ---
  {
    carrier: ['Premier Marine'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['April Marine'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Forward Insurance'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Coast Underwriters'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Oasis Outdoor Adventure'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Agile', 'Guardian Risk'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: true,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: true,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Agile UW', 'HABL'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['PAL'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Orbit', 'Aviva Elite Special Events'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: true,
        direct_bill: false,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Apollo'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
  {
    carrier: ['Aviva Elite'],
    payment_methods: {
      annual: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      monthly: {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: true,
      },
      '2_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '3_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
      '4_pay': {
        eft: false,
        credit_card: false,
        agency_bill: false,
        direct_bill: false,
      },
    },
    credits_cards: {
      visa: false,
      visa_debit: false,
      mastercard: false,
      amex: false,
      mastercard_debit: false,
    },
    down_payment_accept: false,
    down_payment_required: false,
    down_payment_methods: { credit_card: false, e_transfer: false },
    payment_dates: { other: null, annual: null },
    monthly_installments_count: 10,
    loa_billing_required: false,
  },
];

export const PAYMENT_CONFIGS: Record<'auto' | 'home', PaymentOption[]> = {
  auto: AUTO_PAYMENT_OPTIONS,
  home: PROPERTY_PAYMENT_OPTIONS,
};

export const getPaymentConfig = (
  configKey: 'auto' | 'home',
): PaymentOption[] => {
  return PAYMENT_CONFIGS[configKey];
};
